import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { FIRST_PATH } from "../utils/constants";

function withUnAuth<T>(WrapperComponent: React.ElementType) {
  function Auth(props: T) {
    const token = useSelector((state: any) => state.auth.token);
    if (token) {
      return <Navigate to={FIRST_PATH} />;
    }
    return <WrapperComponent {...props} />;
  }
  return Auth;
}
export default withUnAuth;
